// HEPI storefront helpers. Cart logic lives in hepi-cart.js.
// Everything here is called from markup that is actually on the site: the
// collection view toggle and the back-to-top button. Helpers for the old
// filter drawer and the old product gallery were removed with that markup.

// Toast message (bottom of screen). Called from hepi-cart.js.
function showToast(msg){
  var t=document.getElementById('toast');
  var tm=document.getElementById('toastMsg');
  if(!t||!tm)return;
  tm.textContent=msg;
  t.classList.add('show');
  setTimeout(function(){t.classList.remove('show');},2400);
}

// Collection page: grid density toggle (desktop). Called from templates/collection.liquid.
window.setView=function(n,btn){
  document.querySelectorAll('.vbtn').forEach(function(b){b.classList.remove('active');});
  if(btn)btn.classList.add('active');
  var grid=document.getElementById('catGrid');if(grid)grid.className='cat-grid g'+n;
};

// Back-to-top button: only visible once the visitor has scrolled past the fold.
window.addEventListener('scroll',function(){
  var btn=document.getElementById('stBtn');
  if(btn)btn.classList.toggle('show',window.scrollY>400);
},{passive:true});